export const callDispositionsAction = ({ dispositions }) => ({
  type: 'nuxiba_callDispositions',
  dispositions
})

